import { lazy } from 'react'

export const MassUpdateCuratorLazy = lazy(
	() => import('Pages/pp/massUpdateCurator/components/MassUpdateCuratorList')
)
